import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';
import { saveAs } from 'file-saver';

//import * as $ from 'jquery';
//import 'datatables.net';
//import 'datatables.net-bs4';
//declare var $: any;

@Component({
  selector: 'app-view-file',
  templateUrl: './view-file.component.html',
  styleUrls: ['./view-file.component.css']
})
export class ViewFileComponent implements OnInit {
  respObject: any;
  delObject: any;
  fileData:any;

  

  dataType = "";
  fileYear="";
  fullYear: number = new Date().getFullYear();
  yearArr= [];
  yearfArr= [];
  filefYear="";
  selectMonth="";
  fileQuarter="";
  downLoadPath=this._rest.FILE_PATH;

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;
  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(){
    this.dataType = "";
    this.selectMonth="";
    this.fileQuarter="";
    
    this.curPage= 1;

    //const userId = localStorage.getItem('userId');
    //const companyId = localStorage.getItem('companyId');
    for (var i= this.fullYear-10;i<=this.fullYear;i++){
      this.yearArr.push(i);
      //this.fileYear= i+"";
    }
    for (var i= this.fullYear-10;i<=this.fullYear;i++){
      this.yearfArr.push(i+"-"+(i+1));
      //this.filefYear = i+"-"+(i+1);
    }
    const userId = localStorage.getItem('userId');
  	const companyId = localStorage.getItem('companyId');
    this.searchFile(1);
  }
  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
  deleteRequest(id, templateType){
    if(confirm("Are you sure you want to delete?")){
      const data = {
        "fileId":id,
        "templateType": templateType,
        "action": "delete"
        
      }
      this._rest.fileDeleteRequest(data).subscribe((res) => {
        this.delObject=res;
        if(this.delObject.error==0){
          alert(this.delObject.resp);
          //window.location.reload();
          this.ngOnInit();
        } else {
          alert(this.delObject.errorMessage);
        }
      });
    }
  }
  goFileDetailsPage(id){
    this.router.navigate(['/analyst/filedetails/',id]);
  }
  // downloadFile(fData){
  //   console.log(fData);
  //   // this.downLoadPath = '/home/pentation/onlinemis/onlinemis-node/'
  //   // var fileUrl = this.downLoadPath+fData.fileName;
  //   // var fileUrl = fData.filePath +fData.fileName;
  //   // var fileUrl = 'http://localhost:8080/static/'
  //   var fileUrl = 'http://localhost:8080/pent/Flat_Files/Segment-wise/'
  //   console.log(fileUrl)
  //   console.log(fData.fileName)
  //   saveAs(fileUrl+ fData.fileName, fData.fileName);
  //   // fileUrl = 'http://localhost:8080/'
  //   // window.open(fileUrl)
  // }
  downloadFile(fData){
    console.log(fData);
    // var fileUrl = this.downLoadPath+fData.fileName;
    // saveAs(fileUrl, fData.fileName);
    var month   = "";
    var quarter   = "";
    var year    = fData.year;
    var fileType    = "";
    var fullPath    = this.downLoadPath+"Flat_Files/";

    if(fData.templateType=="Segment"){
      fileType  = "Segment-wise";
      month   = fData.monthly;
    } else if(fData.templateType=="Form"){
      fileType  = "Forms";
      quarter   = fData.quarter;
    } else if(fData.templateType=="Financial Highlights"){
      quarter   = fData.quarter;
      fileType  = "FinancialHighlights";
    } else if(fData.templateType=="Gross & Net Statistics"){
      fileType  = "GrossNetStats";
    } else if(fData.templateType=="Data on Motor"){
      fileType  = "DataOnMotor";
      quarter   = fData.quarter;
    } else if(fData.templateType=="Reinsurance"){
      fileType  = "ReInsurance";
      quarter   = fData.quarter;
    } else if(fData.templateType=="Large Loss"){
      fileType  = "LargeLoss";
    }
    // else if(fData.templateType=="MotorPremium"){
    //   fileType  = "MotorPremium";
    //   quarter   = fData.quarter;
    // }

    if(fileType!=""){
      fullPath  = fullPath+fileType+"/";
      
      fullPath  = fullPath+year+"/";
      
      if(month!= undefined && month!=""){
        fullPath  = fullPath+month+"/";
       
      }
      if(quarter!= undefined && quarter!=""){
        fullPath  = fullPath+quarter+"/";
      }
    }
    console.log(fullPath)
    saveAs(fullPath+fData.fileName, fData.fileName);
  }

  searchFile(curPage){
    this.curPage = curPage;
    var fd = {};
    fd["userId"]=localStorage.getItem('userId');
    fd["limit"]=this.perPageRow;
    fd["page"]=this.curPage;
    fd["templateType"]=this.dataType;
    if(this.dataType == "Segment"){
      fd["year"]=this.fileYear;
      fd["monthly"]=this.selectMonth;
    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
      fd["year"]=this.filefYear;
      fd["quarterly"]=this.fileQuarter;
    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){     
      fd["year"]=this.filefYear;
    }
    console.log(fd);
    this._rest.listData(fd).subscribe((res) => {
      this.respObject = res;
      
      if(this.respObject.files.pageInfo!= undefined){
        this.fileData=this.respObject.files.fileInfo;
        this.totalRows = this.respObject.files.pageInfo[0].totalFile;
        this.noOfRows=this.respObject.files.fileInfo.length;
        this.pages=[];
        for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
          this.pages.push(i);
        }
      } else {
        this.fileData=[];
        this.totalRows = 0;
        this.noOfRows = 0;
        this.pages=[];
      }
    })
  }
}
